import { render } from "./vhomeadd.vue?vue&type=template&id=2f9064f5&scoped=true"
import script from "./vhomeadd.vue?vue&type=script&lang=js"
export * from "./vhomeadd.vue?vue&type=script&lang=js"

import "./vhomeadd.vue?vue&type=style&index=0&id=2f9064f5&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9064f5"]])

export default __exports__